import axios from 'axios'

const cards = {
  /**
   * Deletes a card.
   *
   * @param {String} cardId
   * @returns {Promise<Object>}
   */
  deleteCard(cardId) {
    return axios.delete(`/api/cards/${cardId}`)
  },

  /**
   * Enrolls a new card.
   *
   * @param {Object} payload
   * @returns {Promise<Object>}
   */
  addCard(payload) {
    return axios.post('/api/cards', payload)
  },

  /**
   * Edit or Add cards billing address
   * @param {Object} payload - billing address that needs to be edited or added
   * @returns {Promise<Object>}
   */
  manageCard(payload) {
    return axios.post(`/api/cards/${payload.cardId}/address`, payload.address)
  },

  validateCvc(payload, cardId) {
    return axios.post(`/api/cards/${cardId}/validation`, payload)
  }
}

export default cards
